import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";

import { Review } from "../../../../../types/types";
import { testimonialStyles } from "../styles";

import TestimonialCardHeader from "./TestimonialCardHeader";
import TestimonialCardBody from "./TestimonialCardBody";
import TestimonialCardSlider from "./TestimonialCardSlider";

const TestimonialCard = ({ review }: { review: Review }) => {
  const { t } = useTranslation("profiles", { keyPrefix: "testimonials" });

  return (
    <Box sx={testimonialStyles.card.container}>
      <Box sx={testimonialStyles.card.content}>
        <TestimonialCardHeader review={review} />
        <TestimonialCardBody review={review} />
      </Box>
      {review?.media?.length > 0 && <TestimonialCardSlider media={review.media} />}
    </Box>
  );
};

export default TestimonialCard;
